export default function Persongenre() {
  const persongenrearray = [
    'Film score',
    'Hindustani Music',
    'Indipop',
    'Bollywood',
    'Tamil',
    'Telugu',
    'World music',
    'film music',
    'electronic music',
    'comedyseries',
    'Indian classical music',
    'Playback singing',
    'Filmi',
    'Ghazal',
    'rock',
    'blues',
    'Folk music',
    'carnatic music',
    'Rapping',
    'Hip hop music',
    'Indie music',
    'Various',
    'world musicfolk',
    'comedydanceseries',
    'Playback Singer',
    'Pop ',
    'Fusion',
    'Impressionist (entertainment)',
    'Indi-pop',
    'dance music',
    'classical music',
    'theatre',
  ]
  const arraypersonobj = persongenrearray.map(e => ({ value: e, selected: false }))
  return arraypersonobj
}
